import type React from 'react';

export function friendlyMime(mime: string): string {
  if (mime.includes('pdf')) return 'PDF';
  if (mime.includes('jpeg') || mime.includes('jpg')) return 'Imagem JPEG';
  if (mime.includes('png')) return 'Imagem PNG';
  if (mime.includes('webp')) return 'Imagem WebP';
  if (mime.includes('word')) return 'Word';
  if (mime.includes('sheet') || mime.includes('excel')) return 'Planilha';
  if (mime.includes('text')) return 'Texto';
  return mime || '—';
}

export function formatBytes(val: unknown): string {
  const n = Number(val);
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n < 1024) return `${String(n)} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function fmtDate(v: unknown): string {
  if (typeof v === 'string' && v.length >= 10) return v.substring(0, 10);
  return '—';
}

export function SkeletonDetail() {
  return (
    <div style={{ padding: '2.25rem 2.5rem', maxWidth: 800 }}>
      <div
        style={{
          width: 180,
          height: 14,
          background: 'var(--line-soft)',
          borderRadius: 8,
          marginBottom: '1.5rem',
        }}
      />
      <div
        style={{
          width: '60%',
          height: 24,
          background: 'var(--line-soft)',
          borderRadius: 8,
          marginBottom: '2rem',
        }}
      />
      {[1, 2].map((i) => (
        <div
          key={i}
          style={{
            background: '#fff',
            borderRadius: 14,
            border: '1px solid var(--line)',
            padding: '1.25rem 1.5rem',
            height: 100,
            marginBottom: '1rem',
          }}
        >
          <div
            style={{
              width: '30%',
              height: 14,
              background: 'var(--line-soft)',
              borderRadius: 8,
              marginBottom: '0.75rem',
            }}
          />
          <div style={{ width: '60%', height: 12, background: 'var(--soft)', borderRadius: 8 }} />
        </div>
      ))}
    </div>
  );
}

export const Dt = ({ children }: { children: React.ReactNode }) => (
  <dt style={{ color: 'var(--ink)', fontWeight: 600, fontSize: '0.8rem', margin: 0 }}>
    {children}
  </dt>
);
export const Dd = (props: React.HTMLAttributes<HTMLElement> & { children: React.ReactNode }) => (
  <dd style={{ margin: 0, fontSize: '0.85rem', color: 'var(--ink)', ...props.style }}>
    {props.children}
  </dd>
);

export const dlGrid: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '140px 1fr',
  gap: '0.5rem 1rem',
};

export const inputCss: React.CSSProperties = {
  padding: '0.5rem 0.6rem',
  border: '1px solid var(--line)',
  borderRadius: 10,
  fontSize: '0.85rem',
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
};

export const primaryBtn: React.CSSProperties = {
  background: 'var(--green)',
  color: '#fff',
  border: 'none',
  borderRadius: 999,
  padding: '0.45rem 1rem',
  fontSize: '0.8rem',
  fontWeight: 600,
  cursor: 'pointer',
};

export const secondaryBtn: React.CSSProperties = {
  background: '#fff',
  color: 'var(--muted)',
  border: '1px solid var(--line)',
  borderRadius: 999,
  padding: '0.45rem 1rem',
  fontSize: '0.8rem',
  cursor: 'pointer',
};

export const dangerBtn: React.CSSProperties = {
  background: '#fff',
  color: 'var(--danger)',
  border: '1px solid var(--danger-soft)',
  borderRadius: 999,
  padding: '0.45rem 1rem',
  fontSize: '0.8rem',
  cursor: 'pointer',
};

export const linkBtn: React.CSSProperties = {
  background: 'none',
  border: 'none',
  color: 'var(--muted)',
  cursor: 'pointer',
  fontSize: '0.875rem',
  marginBottom: '0.5rem',
  display: 'block',
  padding: 0,
};

export const fieldLabel: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  fontSize: '0.8rem',
  color: 'var(--ink)',
  fontWeight: 600,
};

export const modalOverlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'var(--overlay)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 100,
};

export const modalStyle: React.CSSProperties = {
  background: '#fff',
  borderRadius: 14,
  padding: '1.5rem',
  minWidth: 360,
  maxWidth: 460,
};
